import { Button, Col, Form, Input, Layout, Row } from "antd";
import { useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import signinLogo from "../../assets/images/logo-for-logins.png";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";

const { Content } = Layout;

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { state } = useLocation(); // expecting { email } from navigate
  const { token } = useParams(); // get token from URL
  const { request } = useRequest();

  const onSubmit = (values) => {
    const { password, confirmPassword } = values;
    if (password !== confirmPassword) {
      return ShowToast("Passwords do not match", Severty.ERROR);
    }

    const payload = {
      email: state?.email, // email from previous step (like OTP verification)
      password,
    };

    setLoading(true);
    request({
      url: apiPath.resetPasswordWithToken(token),
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        ShowToast(
          data?.message || "Password reset successful!",
          Severty.SUCCESS
        );
        navigate("/login"); // redirect to login
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(
          error.response?.data?.message || "Failed to reset password",
          Severty.ERROR
        );
      },
    });
  };

  return (
    <div className="main-new-login-page-designe-divv">
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row>
            <Col span={24} lg={24} className="contant-bg-sign">
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={signinLogo} alt="Reset Password logo" />
                  <h4> Reset Your Password </h4>
                </div>

                <Form
                  form={form}
                  onFinish={onSubmit}
                  layout="vertical"
                  className="row-col"
                >
                  <Form.Item
                    label="New Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your new password!",
                      },
                      {
                        min: 6,
                        message: "Password must be at least 6 characters",
                      },
                    ]}
                  >
                    <Input.Password placeholder="Enter New Password" />
                  </Form.Item>

                  <Form.Item
                    label="Confirm Password"
                    name="confirmPassword"
                    dependencies={["password"]}
                    rules={[
                      {
                        required: true,
                        message: "Please confirm your password!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords do not match!")
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password placeholder="Confirm New Password" />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Reset Password
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </div>
  );
};

export default ResetPassword;
